/* global swal, _, angular*/
import './style.less';
import { flatten } from 'lodash';

export default function($log, $timeout, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.callback = selectedTags => {
    vm.ngModel = (selectedTags || []).map(({ uuid }) => uuid);
    $timeout(() => {
      vm.action();
    }, 0);
  };

  function expose(tagItems) {
    const tagsDict = tagItems.reduce((obj, { tags }) => {
      return { ...obj, ...tags };
    }, {});

    if (vm.ngModel && vm.ngModel.length) {
      vm.selectedTags = vm.ngModel.map(uuid => tagsDict[uuid]);
    }

    const groupArrays = tagItems
      .map(({ tagCategory, tags }) => {
        return Object.values(tags).map(tag => {
          tag.group = tagCategory.name;
          return tag;
        });
      })
      .filter(tag => tag && tag.length);

    let tags = flatten(groupArrays);

    if (vm.existingTags) {
      tags = tags.filter(({ uuid }) => vm.existingTags.includes(uuid));
    }

    vm.tagsList = tags;
  }

  function activate() {
    $log.debug('Tags Component Activated');

    const allowedItemTypes = vm.allowedItemType && [vm.allowedItemType];

    ApiClass.companiesIdTypeGet({ manage: false, id: company_id, type: 'tagCategories' }, null, {
      queryParams: { filter: JSON.stringify({ allowedItemTypes }) }
    })
      .then(({ data: { items: tagCategory } }) => expose(tagCategory))
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/tags/controller.js